export default class PressureProcessingSettings {
  COP_Computing_THR: number = 4;
  AutoCrop_SumTHR: number = 20;
  AutoCrop_Margin: number = 2;
  AutoAxis_SumCount: number = 5;
  AutoAxis_SumThr: number = 20;
  AutoWidth_SumCount: number = 10;
  AutoWidth_SumThr: number = 20;
  Surface_Thr: number = 1; //16;
  ZoneSensorVisibleThr: number = 20;  //30;
  COP_SUM_THR: number = 5;

  ResetToDefault() {
    this.COP_Computing_THR = 4;
    this.AutoCrop_SumTHR = 20;
    this.AutoCrop_Margin = 2;
    this.AutoAxis_SumCount = 5;
    this.AutoAxis_SumThr = 20;
    this.AutoWidth_SumCount = 10;
    this.AutoWidth_SumThr = 20;
    this.Surface_Thr = 1; //16;
    this.ZoneSensorVisibleThr = 20; //30;
    this.COP_SUM_THR = 5;
  }
}